import React, {PureComponent } from 'react'
import { translate } from './translate';

class BenchmarkSelector extends PureComponent {
  constructor() {
    super()
    this.state = {
      expanded: false
    }
    this.handleOptionClicked = this.handleOptionClicked.bind(this)
  }
  handleOptionClicked(option) {
    const { onSelect, selected } = this.props
    const newSelection = selected.concat()
    const indexInSelection = selected.indexOf(option)
    if (indexInSelection > -1) {
      newSelection.splice(indexInSelection, 1)
    }
    else {
      newSelection.push(option)
    }
    onSelect(newSelection)
  }
  render() {
    const { options, selected, i18n, lang } = this.props
    const { expanded } = this.state

    if (options[0].symbol != null) {
    return (
      
      <div 
        className='BenchmarkSelector Selector'
        onMouseEnter={() => this.setState({ expanded: true })}
        onMouseLeave={() => this.setState({ expanded: false })}
      >
        <div className='BenchmarkSelector-expander Selector-option'>
          {translate('COMPARISON', i18n, lang)} {selected.length > 0 ? `(${selected.length})` : ''}</div>
        <div 
          className='BenchmarkSelector-dropdown'
          style={{display: expanded ? '' : 'none'}}
        >{
          options.map(
            (option, i) => <div
              key={option.symbol + i}
              className={`Selector-option ${selected.indexOf(option.symbol) > -1 ? 'Selector-selected' : ''}`}
              onClick={() => this.handleOptionClicked(option.symbol)}
            >
              <div className='BenchmarkSelector-option-name'  >{option.name}&nbsp;</div>
              <div className='BenchmarkSelector-option-symbol'>({option.symbol})</div>
            </div>
          )
        }</div>
      </div>
    )}
    else return null
  }
}

export default BenchmarkSelector


// WEBPACK FOOTER //
// ./src/BenchmarkSelector.js